<button
    class="ym-text-decoration-none ym-focus--focus ym-bg-transparent ym-font-sm ym-ml-2 ym-hover-text-decoration-underline ym-font-sm ym-text-secondary ym-border-none"
    (click)="openWidget()">Feedback</button>

<div class="feedback-widget ym-fixed ym-left-4 ym-bottom-7 ym-pr-3 ym-opacity-0" *ngIf="isWidgetOpen">
    <ym-feedback [label]="'How would you rate your experience with the app?'" (onClose)="closeWidget()"
        [isEaseUseFeedback]="false" (onFeedbackSubmit)="feedbackSubmit($event)"></ym-feedback>
</div>